import React from "react";

export type ValuationDateStatus = "green" | "orange" | "red";

export const VALUATION_DATE_STATUS_STYLES: Record<ValuationDateStatus, { backgroundColor: string; color: string }> = {
    green: { backgroundColor: "#16a34a", color: "#ffffff" },
    orange: { backgroundColor: "#ca8a04", color: "#ffffff" },
    red: { backgroundColor: "#dc2626", color: "#ffffff" }
};

export function getValuationDateStatus(
    valuationDate: string | null | undefined,
    referenceDate: string
): ValuationDateStatus | undefined {
    if (!valuationDate || !referenceDate || !/^\d{4}-\d{2}-\d{2}/.test(referenceDate)) {
        return undefined;
    }

    const parseYmdToUtcMs = (ymd: string): number => {
        const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
        if (!match) return NaN;
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        return Date.UTC(year, month - 1, day);
    };

    const refYmd = referenceDate.substring(0, 10);
    const priceYmd = valuationDate.substring(0, 10);

    const refMs = parseYmdToUtcMs(refYmd);
    const priceMs = parseYmdToUtcMs(priceYmd);

    if (!Number.isFinite(refMs) || !Number.isFinite(priceMs)) {
        return undefined;
    }

    const diffDays = (priceMs - refMs) / 86400000;

    if (diffDays >= -1 && diffDays <= 1) {
        return "green";
    }
    if (diffDays >= 2) {
        return "red";
    }
    const refMinusMonth = new Date(refMs);
    refMinusMonth.setUTCMonth(refMinusMonth.getUTCMonth() - 1);
    if (priceMs < refMinusMonth.getTime()) {
        return "red";
    }
    return "orange";
}

interface ValuationDateCellProps {
    value: string | null | undefined;
    referenceDate: string;
}

export function ValuationDateCell({ value, referenceDate }: ValuationDateCellProps): React.ReactElement {
    const status = getValuationDateStatus(value, referenceDate);
    if (!status) {
        return <div>{value ?? ""}</div>;
    }
    return (
        <div
            style={{
                ...VALUATION_DATE_STATUS_STYLES[status],
                display: "inline-block",
                padding: "2px 6px",
                borderRadius: "3px",
                lineHeight: 1.2
            }}
        >
            {value ?? ""}
        </div>
    );
}
